import {
  FolderDto,
  LocationDto,
  SearchResultsDto,
} from "@braoshzmvavz/picnube-common";
import {
  Group,
  LoadingOverlay,
  useComputedColorScheme,
  useMantineTheme,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React, { useEffect, useState } from "react";
import { HiFolder } from "react-icons/hi";
import { MdFolder } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import useApi from "src/services/useApi";

export default function LocationRelatedContent(props: {
  location: LocationDto;
}) {
  const computedColorScheme = useComputedColorScheme("dark");
  const [isLoading, setIsLoading] = useState(true);

  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const navigate = useNavigate();

  const [folders, setFolders] = useState<FolderDto[]>([]);

  const { searchByLocation } = useApi();

  useEffect(() => {
    setIsLoading(true);
    searchByLocation(props.location.id).then((response: SearchResultsDto) => {
      setFolders(response.folders);
      setIsLoading(false);
    });
  }, [props.location.id]);

  const renderFolderIcon = (folder: FolderDto) => {
    if (isMobile) {
      return (
        <div className="relative">
          <MdFolder className="text-2xl text-blue-400" />
        </div>
      );
    }

    return <HiFolder className="xs:text-7xl text-2xl text-blue-400" />;
  };

  const extractFolderPath = (path: string) => {
    const parts = path.split(";");
    const folderNames = parts.map((part) => part.split(":")[1]);

    if (folderNames.length === 0) return "";

    return folderNames.join("/");
  };

  return (
    <div className="flex w-full h-full">
      <LoadingOverlay
        visible={isLoading}
        zIndex={400}
        overlayProps={{
          blur: "xl",
          color: computedColorScheme === "dark" ? "black" : "black",
          opacity: computedColorScheme === "dark" ? "70%" : "30%",
        }}
        loaderProps={{ color: "blue", type: "oval", size: "md" }}
      ></LoadingOverlay>

      {!isLoading && folders.length != 0 && (
        <div className="flex h-full w-full flex-col gap-2 border-t border-grey-800 py-6">
          <h1>Folders</h1>
          <div className="flex w-full flex-col items-start justify-start gap-2">
            {folders.map((folder) => {
              return (
                <div
                  key={folder.id}
                  className="flex flex-row items-center gap-2 p-1 hover:bg-grey-800 cursor-pointer rounded-lg w-full"
                  onClick={() => navigate(`/browse/${folder.id}`)}
                >
                  <div className="flex justify-center items-center rounded-full min-w-8 min-h-8">
                    <HiFolder className="w-5 h-5"></HiFolder>
                  </div>
                  <div>
                    <div className="text-md">{folder.name}</div>
                    <div className="text-xs text-grey-600">
                      {extractFolderPath(folder.path)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {!isLoading && folders.length == 0 && (
        <div className="text-lg flex flex-col w-full h-full items-center justify-center">
          No content found in this location
        </div>
      )}
    </div>
  );
}
